var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-background"},[_c('div',{attrs:{"id":"login"}},[_c('v-row',{attrs:{"justify":"space-around"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"login"},[_c('hot-line-card',{attrs:{"isActive":_vm.isActive}})],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }